import { useState } from 'react';
import { Icon } from '../../Atoms/Icon';
import { TextSpan } from '../../Atoms/Text';
import { ServiceRequestForm } from './ServiceRequestForm';

interface ServiceRequestProps {
  ctaClassName: string;
  label?: string;
  showIcon?: boolean;
}

export function ServiceRequestLink({ ctaClassName, label = 'New Request', showIcon = true }: ServiceRequestProps) {
  const [open, setOpen] = useState(false);

  const onClose = async () => {
    setOpen(false);
  };

  return (
    <>
      <TextSpan className="flex items-center space-x-2">
        {showIcon && <Icon type="plus" />}
        <button
          className={ctaClassName}
          data-cy="new-service-request"
          onClick={() => setOpen(true)}>
          {label}
        </button>
      </TextSpan>
      <ServiceRequestForm
        open={open}
        onClose={onClose}
      />
    </>
  );
}
